module.exports = __webpack_public_path__ + "static/media/BenFaulkner.b1978eae.png";